<template>
  <v-dialog v-model="dialog" persistent :max-width="customStyles.maxWidth">
    <v-card color="surface lighten-1">
      <v-card-title class="header">
        {{ title }}
      </v-card-title>

      <v-card-text>
        <div class="confirmation-dialog-message">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="description"></div>
        </div>
      </v-card-text>
      <div class="px-6">
        <v-text-field v-model="text" :label="placeholder" clearable />
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn color="primary" depressed @click="accept()">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EcsAddNoteDialog',

  props: {
    customStyles: {
      type: Object,
      default: () => {
        return { maxWidth: '400px' };
      }
    }
  },

  data() {
    return {
      dialog: false,
      text: '',
      title: '',
      description: '',
      placeholder: '',
      confirmButtonText: '',
      cancelButtonText: ''
    };
  },

  methods: {
    open({ title, description, placeholder, confirmButtonText, cancelButtonText }) {
      this.dialog = true;
      this.text = '';
      this.title = title || '';
      this.description = description || '';
      this.placeholder = placeholder || '';
      this.confirmButtonText = confirmButtonText || 'Confirm';
      this.cancelButtonText = cancelButtonText || 'Cancel';

      return new Promise((resolve, reject) => {
        this.$once('confirm', resolve);
      });
    },
    accept() {
      this.dialog = false;
      this.$emit('confirm', this.text);
    },
    cancel() {
      this.dialog = false;
      this.$emit('confirm', false);
    }
  }
};
</script>

<style scoped>
.confirmation-dialog-message {
  font-size: 13px;
  word-break: break-word;
}

h3 {
  letter-spacing: 0.1em;
}
</style>
